import React, { Component } from 'react'
import head from "../../assets/images/head.png"
import './css/join.css'
import hendray from "../../assets/images/hendray.png"
import clockIcon from "../../assets/images/clockIcon.png"

class Join extends Component {
    render() {
        return (
            <div className="join">
                <div className="ls-width">
                    <div className="learning-sessions">
                        <div className="ls-text">
                            <h2>Join daily & weekly live <br /> sessions with our educators.
                        </h2>
                            <p>
                            Follow up reviews of what is going on in the market; targeted at traders and sometimes newbies. Ask questions and get to know what’s going on in our community.
                        </p>
                        </div>
                        <div className="ls-card">
                            <div className="learning-card br-3">
                                <div className="lc-img">
                                    <img src={hendray} alt="CEO IMAGE" />
                                </div>
                                <div>
                                    <h6>Market Overview & Trade Setups</h6>
                                    <p>Adekanbi Idowu, Financial Market Analyst</p>
                                    <div className="lc-small">
                                        <img src={clockIcon} />
                                        <span>
                                            to be communicated on all our social media platform
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div className="learning-card br-3">
                                <div className="lc-img">
                                    <img src={hendray} alt="CEO IMAGE" />
                                </div>
                                <div>
                                    <h6>Market Overview & Trade Setups</h6>
                                    <p>Adekanbi Idowu, Financial Market Analyst</p>
                                    <div className="lc-small">
                                        <img src={clockIcon} />
                                        <span>
                                            to be communicated on all our social media platform
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div className="learning-card br-3">
                                <div className="lc-img">
                                    <img src={hendray} alt="CEO IMAGE" />
                                </div>
                                <div>
                                    <h6>Market Overview & Trade Setups</h6>
                                    <p>Adekanbi Idowu, Financial Market Analyst</p>
                                    <div className="lc-small">
                                        <img src={clockIcon} />
                                        <span>
                                            to be communicated on all our social media platform
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            
        )
    }
}

export default Join;